<template>
  <div>
    <v-form
      class="bg-light py-md-3 py-1 px-3 rounded mb-1"
      @submit.prevent="save()"
    >
      <div class="row">
        <div class="col-1">
          <div class="mb-1">
            ID: {{ course.id }}
          </div>
          <div class="mb-1">
            Code: {{ course.code }}
          </div>
        </div>
        <div class="col-2">
          <div class="pb-0">
            <v-text-field
              v-model="course.name"
              variant="outlined"
              density="compact"
              bg-color="white"
              label="Name*"
              :error-messages="v$.course.name.$errors.map((e) => e.$message)"
              @blur="v$.course.name.$touch()"
            />
          </div>
          <v-checkbox
            v-model="course.buyable"
            :value="1"
            :unchecked-value="0"
            label="Can buy"
          />
        </div>
        <div class="col-2">
          <div class="pb-0">
            <v-select
              v-model="course.certificate_id"
              variant="outlined"
              density="compact"
              bg-color="white"
              label="Certificate"
              :item="certificateOptions"
              item-value="id"
              item-titel="name"
            />
          </div>
        </div>
        <!-- <div class="col-1">
          <div class="pb-0">
            <v-text-field
            variant="outlined"
            density="compact"
            bg-color="white"
              v-model="course.license_validity_period"
              :class="{ 'is-invalid': v$.course.license_validity_period.$error, 'label-top': course.license_validity_period}"
              type="number"
              @blur="v$.course.license_validity_period.$touch()"
            />
            <label>License Valid (days)*</label>
            <div v-if="v$.course.license_validity_period.$error" class="invalid-feedback">
              Cert expiration term is required
            </div>
          </div>
        </div> -->
        <div class="col-1">
          <v-checkbox
            v-model="course.ansi_approved"
            value="1"
            unchecked-value="0"
            label="ANSI Approved"
          />
        </div>
        <div class="col-1">
          <div class="pb-0">
            <v-text-field
              v-model="course.total_quizzes"
              variant="outlined"
              density="compact"
              bg-color="white"
              label="Total Public Quizzes*"
              type="number"
              :error-messages="
                v$.course.total_quizzes.$errors.map((e) => e.$message)
              "
              @blur="v$.course.total_quizzes.$touch()"
            />
          </div>
        </div>
        <div class="col-1">
          <div>
            Quizzes
            <a
              href="#"
              tabindex="0"
              class="font-icon-edit h5 pl-2 mb-0"
              @click.prevent="isQuizzesEditModalOpen = true"
            />
          </div>
          <div>
            Survey Questions
            <a
              href="#"
              tabindex="0"
              class="font-icon-edit h5 pl-2 mb-0"
              @click.prevent="isSurveyQuestionEditModalOpen = true"
            />
          </div>
          <div>
            Folder Management
            <a
              href="#"
              tabindex="0"
              class="font-icon-edit h5 pl-2 mb-0"
              @click.prevent="isFolderManagementModalOpen = true"
            />
          </div>
        </div>

        <div class="col-2">
          <strong>Languages:</strong>
          <span>
            <v-tooltip
              width="300px"
              activator="parent"
              location="bottom start"
              location-strategy="connected"
              class="option-tooltip"
            >
              Available training languages visible to user upon course start
              <template #activator>
                <v-icon icon="mdi:mdi-information-outline" size="x-small" />
              </template>
            </v-tooltip>
          </span>
          <v-autocomplete
            v-model="languagesValue"
            bg-color="white"
            chips
            variant="outlined"
            density="compact"
            item-value="id"
            item-title="name"
            :items="lookup.languages"
            :multiple="true"
          />
        </div>

        <div class="col-1">
          <button
            type="button"
            class="btn btn-default btn-sm"
            :disabled="isLoading"
            @click="save"
          >
            Save
            <span
              v-show="isLoading"
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            />
          </button>
        </div>
      </div>
    </v-form>
    <v-dialog
      v-model="isQuizzesEditModalOpen"
      max-width="1140px"
    >
      <v-card>
        <template #title>
          <div class="d-flex justify-space-between align-center">
            <span>{{ course.id+' - '+course.name+' Quizzes' }}</span>
            <v-btn
              variant="plain"
              @click="isQuizzesEditModalOpen = false"
            >
              <i class="fas fa-times" />
            </v-btn>
          </div>
        </template>
        <v-divider />
        <div class="px-3 pb-4">
          <elearning-course-quiz
            v-for="(quiz, i) in course.elearning_quizzes"
            :key="quiz.id"
            v-model="course.elearning_quizzes[i]"
            :index="i"
          />
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="isSurveyQuestionEditModalOpen"
      max-width="1140px"
    >
      <v-card>
        <template #title>
          <div class="d-flex justify-space-between align-center">
            <span>{{ course.id+' - '+course.name+' Survey Questions' }}</span>
            <v-btn
              variant="plain"
              @click="isSurveyQuestionEditModalOpen = false"
            >
              <i class="fas fa-times" />
            </v-btn>
          </div>
        </template>
        <v-divider />
        <div class="px-3 pb-4">
          <elearning-survey-question
            v-for="(elearning_survey_question, i) in course.elearning_survey_questions"
            :key="elearning_survey_question.id"
            v-model="course.elearning_survey_questions[i]"
            :index="i"
          />
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="isFolderManagementModalOpen"
      max-width="1140px"
    >
      <v-card>
        <template #title>
          <div class="d-flex justify-space-between align-center">
            <span>{{ course.id+' - '+course.name+' Folder Management' }}</span>
            <v-btn
              variant="plain"
              @click="isFolderManagementModalOpen = false"
            >
              <i class="fas fa-times" />
            </v-btn>
          </div>
        </template>
        <v-divider />
        <div class="px-3 pb-4">
          <elearning-folder-manager v-model="course" />
        </div>
      </v-card>
    </v-dialog>
  </div>
  <v-snackbar
    v-model="isSnackbarOpen"
    :timeout="3000"
    location="top right"
  >
    <v-alert
      color="#dfe8e8"
      :title="title"
      :text="message"
    />
  </v-snackbar>
</template>

<script>
import axios from 'axios';
import { useVuelidate } from '@vuelidate/core';
import { lookup } from '../lookup/lookup';

import { appValidator } from '../../common/core/utils/validator';
import ElearningCourseQuiz from './elearningCourseQuiz.vue';
import ElearningSurveyQuestion from './elearningSurveyQuestion.vue';
import ElearningFolderManager from './elearningFolderManager.vue';

export default {
  components: {
    ElearningCourseQuiz,
    ElearningSurveyQuestion,
    ElearningFolderManager,
  },
  props: ['modelValue', 'index', 'certificates'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      // course: Object.assign({}, this.modelValue)
      course: { ...this.modelValue },
      isLoading: false,
      lookup,
      certificateOptions: [{ id: null, name: 'Course Has No Certificate' }],
      languagesValue: [],
      isQuizzesEditModalOpen: false,
      isSurveyQuestionEditModalOpen: false,
      isFolderManagementModalOpen: false,
      isSnackbarOpen: false,
      message: '',
      title: '',
    };
  },

  watch: {
    languagesValue: {
      handler(newValues) {
        this.course.languages = newValues.map(language => this.lookup.languages.find(l => l.id === language));
      },
    },
  },

  async mounted() {
    this.languagesValue = this.course.languages.map(l => l.id);
    this.course.elearning_survey_questions.sort(
      (a, b) => a.language_id - b.language_id,
    );

    this.certificates.forEach(certificate => {
      this.certificateOptions.push({
        id: certificate.id,
        name: `(${certificate.id})  ${certificate.name}`,
      });
    });
  },
  /* watch: {
        course: {
            deep: true,
            handler: function(value) {
                console.log(value);
            }
        }
    }, */

  validations() {
    return {
      course: {
        name: {
          required: appValidator.required,
        },
        /* license_validity_period: {
                    required
                }, */
        total_quizzes: {
          required: appValidator.required,
        },
      },
    };
  },

  methods: {
    validate() {
      let error = false;
      if (this.v$.$invalid) {
        this.v$.$touch();
        error = true;
      }

      return !error;
    },

    async save() {
      if (!this.validate()) {
        return;
      }

      this.isLoading = true;
      await axios.put(
        `/api/elearning/courses/${this.course.id}`,
        this.course,
      );
      this.isLoading = false;
      this.openSnackbar('Saved', this.course.name);

      // this.$emit('input', this.course);
    },
    openSnackbar(title, message) {
      this.isSnackbarOpen = true;
      this.title = title;
      this.message = message;
    },
  },
};
</script>
